import { Button, Card, CardActionArea, CardContent, Grid, Typography } from "@mui/material";
import { useState } from "react";
import DataTable from "../../components/features/Datatable";
import DemoForm from "./DemoForm";


const Dashboard = () => {
  const [selectedCard, setSelectedCard] = useState(0);

  const updateFilter = () => {}

  // const data = [
  //   {
  //     id: 1,
  //     title: 'Total Page Views',
  //     description: '4,42,236',
  //   },
  //   {
  //     id: 2,
  //     title: 'Total Users',
  //     description: '78,250',
  //   },
  //   {
  //     id: 3,
  //     title: 'Total Order',
  //     description: '18,800',
  //   },
  //   {
  //     id: 3,
  //     title: 'Total Sales',
  //     description: '$35,078',
  //   },
  // ];

  const columns = [
    {
      id: 'patient_id',
      name: 'ID',
      selector: row => row.patient_id,
      sortable: true
    },
    {
      id: 'name',
      name: 'Subject Name',
      selector: row => row.name,
      sortable: true
    },
    {
      id: 'product',
      name: 'Product/Phase',
      selector: row => `${row.product}/${row.phase}`,
      sortable: true
    },
    {
      id: 'type',
      name: 'Type',
      selector: row => row.type,
      sortable: true
    },
    {
      id: 'hospital',
      name: 'Hospital',
      selector: row => row.hospital,
      sortable: true
    },
    {
      id: 'status',
      name: 'Status',
      selector: (row) =>
        row.status ? (
          <p
            className={`${
              row.status === "Shipped"
                ? "text-[#00B278]"
                : row.status === "Pending"
                ? "text-[#FB9D2C]" 
                : row.status === "Cancelled"
                ? "text-[#FF2023]" 
                : row.status === "Delivered"
                ? "text-[#3B82F6]"
                : row.status === "Processing"
                ? "text-[#F97316]" 
                : "text-[#6B7280]" 
            } font-roboto font-normal text-[14px] leading-[100%] tracking-[0%]`}
          >
            {row?.status}
          </p>
        ) : (
          "N/A"
        ),
      sortable: true
    },
    {
      name: 'Action',
      selector: row => <Button key={row.id} size="small" className="!w-[100px]">View Details</Button>,
    },
  ];

  const data = {
    items: [
      {
        "id": 1,
        "patient_id": "P03C132LUCMED01LYP001",
        "name": "Ramesh Rajput",
        "product": "BCMA",
        "phase": "Phase 2",
        "type": "PMS",
        "hospital": "Max Super Specialty",
        "status": "Shipped"
      },
      {
        "id": 2,
        "patient_id": "P03C132LUCMED01LYP002",
        "name": "Anita Sharma Gulati",
        "product": "CAR-T",
        "phase": "Phase 1",
        "type": "Clinical Trial",
        "hospital": "Apollo Hospital",
        "status": "Pending"
      },
      {
        "id": 3,
        "patient_id": "P03C132LUCMED01LYP003",
        "name": "Rahul Verma",
        "product": "Gene Therapy",
        "phase": "Phase 3",
        "type": "PMS",
        "hospital": "Fortis Hospital",
        "status": "Delivered"
      },
      {
        "id": 4,
        "patient_id": "P03C132LUCMED01LYP004",
        "name": "Pooja Malhotra",
        "product": "BCMA",
        "phase": "Phase 2",
        "type": "Clinical Trial",
        "hospital": "Medanta Hospital",
        "status": "Processing"
      },
      {
        "id": 5,
        "patient_id": "P03C132LUCMED01LYP005",
        "name": "Suresh Patil",
        "product": "CAR-T",
        "phase": "Phase 1",
        "type": "PMS",
        "hospital": "AIIMS",
        "status": "Cancelled"
      },
      {
        "id": 6,
        "patient_id": "P03C132LUCMED01LYP006",
        "name": "Kavita Das",
        "product": "Gene Therapy",
        "phase": "Phase 3",
        "type": "Clinical Trial",
        "hospital": "Manipal Hospital",
        "status": "Shipped"
      },
      {
        "id": 7,
        "patient_id": "P03C132LUCMED01LYP007",
        "name": "Manoj Kumar",
        "product": "BCMA",
        "phase": "Phase 2",
        "type": "PMS",
        "hospital": "CMC Vellore",
        "status": "Pending"
      },
      {
        "id": 8,
        "patient_id": "P03C132LUCMED01LYP008",
        "name": "Jyoti Mehta",
        "product": "CAR-T",
        "phase": "Phase 1",
        "type": "Clinical Trial",
        "hospital": "Narayana Health",
        "status": "Processing"
      },
      {
        "id": 9,
        "patient_id": "P03C132LUCMED01LYP009",
        "name": "Amit Bhardwaj",
        "product": "Gene Therapy",
        "phase": "Phase 3",
        "type": "PMS",
        "hospital": "Tata Memorial Hospital",
        "status": "Delivered"
      },
      {
        "id": 10,
        "patient_id": "P03C132LUCMED01LYP010",
        "name": "Sunita Yadav",
        "product": "BCMA",
        "phase": "Phase 2",
        "type": "Clinical Trial",
        "hospital": "Kokilaben Hospital",
        "status": "Shipped"
      },
      {
        "id": 11,
        "patient_id": "P03C132LUCMED01LYP011",
        "name": "Vikram Singh",
        "product": "CAR-T",
        "phase": "Phase 1",
        "type": "PMS",
        "hospital": "Jaypee Hospital",
        "status": "Cancelled"
      },
      {
        "id": 12,
        "patient_id": "P03C132LUCMED01LYP012",
        "name": "Neha Choudhary",
        "product": "Gene Therapy",
        "phase": "Phase 3",
        "type": "Clinical Trial",
        "hospital": "Sankara Nethralaya",
        "status": "Processing"
      },
      {
        "id": 13,
        "patient_id": "P03C132LUCMED01LYP013",
        "name": "Arun Nair",
        "product": "BCMA",
        "phase": "Phase 2",
        "type": "PMS",
        "hospital": "Global Hospitals",
        "status": "Delivered"
      }
    ]
  };

  return (
    <Grid container className='m-4 ml-0 mainDiv' rowSpacing={4.5} columnSpacing={2.75}>
      {/* <Grid item xs={12} sx={{ mb: -2.25 }}>
        <Typography variant="h5">Dashboard</Typography>
      </Grid> */}
      {[].map((item, index) => (
        <Grid key={index} item xs={12} sm={6} md={4} lg={3}>
          <Card>
            <CardActionArea
              onClick={() => setSelectedCard(index)}
              data-active={selectedCard === index ? '' : undefined}
              sx={{
                height: '100%',
                '&[data-active]': {
                  backgroundColor: 'action.selected',
                  '&:hover': {
                    backgroundColor: 'action.selectedHover',
                  },
                },
              }}
            >
              <CardContent sx={{ height: '100%' }}>
                <Typography variant="h5" component="div">
                  {item.title}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {item.description}
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>
      ))}
      <Grid item xs={12} sx={{ mt: -2.25 }}>
        <DataTable
          columns={columns}
          data={data}
          title="Subject"
          FilterComponent={DemoForm}
          // isServerSide={true}
          onServerSideChange={updateFilter}
        />
      </Grid>
    </Grid>
  );
};

export default Dashboard;
